module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/3/3-df57c13c3971b3ea8bcf2789fba23bf3.jpg";